import axiosInstance from "../AxiosInstance";
import { URLS } from "../API/API endpoints";
import { store } from "../Redux/store";
import i18next from "i18next";

const { login } = store.getState();

// const user_id = login.user;
// const store_id = login.user;


export const getPosSessionList = async (user_id) => {
  try {
    const payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      user_id: user_id,
      // store_id: company_id,
    };
    const response = await axiosInstance.post(URLS.GET_POS_SESSIONS, payload);
    // console.log("Shipping Cost", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPosSessionHistory = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_POS_SESSION_HISTORY, payload);
    console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getCreditHistory = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CREDIT_HISTORY, payload);
    console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const getCustomers = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_CUSTOMERS, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const createNewCustomer = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CREATE_NEW_CUSTOMER, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateExistingCustomer = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.UPDATE_CUSTOMER, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const cashInOutReport = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.CASH_IN_OUT_REPORT, payload);
    console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const posOrders = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_POS_ORDERS, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};


export const getPosOrderLines = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_POS_ORDER_LINES, payload);
    console.log("GET_POS_ORDERLINES RES", response);

    return response?.data;
  } catch (error) {
    return error;
  }
};



export const posSaleSummary = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_POS_SALE_SUMMARY, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const GetItemWiseSaleData = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_ITEM_WISE_SALE, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};


export const getExpiryProducts = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.GET_PRODUCT_EXPIRY, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};

export const posOrderFromDelivery = async (payload) => {
  try {
    const response = await axiosInstance.post(URLS.POS_ORDER_FROM_SUMMARY, payload);
    // console.log("GET_POS_SESSION_HISTORY", response);

    return response.data;
  } catch (error) {
    return error;
  }
};